/**
 * Blocks MY-LEX document Escape handling (keyup capture on document) while a hosted
 * React modal is open. Registered at module load so it runs before handlers added when
 * a document panel opens.
 *
 * Longer term, consider reusing `activateDocumentEscapeBlocker` from the loaded
 * MyLex.Web.Components `jsInterop.js` bundle to avoid parallel Escape mechanisms.
 */
let guardActive = false;

document.addEventListener('keyup', (event: KeyboardEvent) => {
    if (event.key === 'Escape' && guardActive) {
        event.stopImmediatePropagation();
    }
}, true);

/**
 * Activates the Escape guard before showing a hosted modal.
 */
export function activateDocumentEscapeGuard(): void {
    guardActive = true;
}

/**
 * Deactivates the Escape guard after the hosted modal has fully closed.
 */
export function deactivateDocumentEscapeGuard(): void {
    guardActive = false;
}
